import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import * as firebase from "firebase";
import { CoreComponentAjaxUtils, getAjaxhelper } from 'src/utils';
import { BookingData } from 'src/shared';
import { History } from 'history';

export interface BookingChecoutProgressPanelProps extends BaseComponentProps {
    checkoutId: number;
    database: firebase.database.Database;
    history: History;

}

interface FBResponseData {
    checkoutId: number;
    statusCode: BookingData.bookingCheckoutStatus;
    errorMessage?: string;
    headerId?: number;
}

export interface BookingChecoutProgressPanelState extends BaseComponentState {
    fbRespons: FBResponseData;
}

export class BookingChecoutProgressPanel extends BaseComponent<BookingChecoutProgressPanelProps, BookingChecoutProgressPanelState> {

    constructor(props: BookingChecoutProgressPanelProps) {
        super(props);
        this.state = {
            fbRespons: {
                checkoutId: props.checkoutId,
                statusCode: "REQUESTING"
            }
        };
    }

    componentDidMount() {
        const onListenToFirebaseError: (err: any) => any = (err: any) => {
            console.error("RealtimeDB ERROR ", err);
        };

        new CoreComponentAjaxUtils(getAjaxhelper()).getDataByIdWithPromise(this.props.checkoutId, "BookingCheckOut", [{ modelName: "BookingHeaderSimple" }]).then(
            (d: BookingData.BookingCheckOut) => {
                if (d.statusCode === "COMPLETE") {
                    this.props.history.push("/voucher-confirmed?id=" + d.BookingHeaderSimple!.localReffNo);
                }
                //
                const reff = this.props.database.ref(d.docPath!);
                reff.on(
                    'value',
                    snapshot => {
                        if (!snapshot || !snapshot.exists()) {
                            return;
                        }
                        var nilai: FBResponseData = snapshot.val();
                        if (nilai.statusCode === "COMPLETE" || nilai.statusCode === 'ERROR' || nilai.statusCode === "HOTELBED_REQUEST_COMPLETE") {
                            reff.off("value");
                        }
                        this.setStateHelper(
                            st => {
                                st.fbRespons = nilai;
                            },
                            () => {
                                if (nilai.statusCode === "HOTELBED_REQUEST_COMPLETE") {
                                    new CoreComponentAjaxUtils(getAjaxhelper()).getDataByIdWithPromise(nilai.headerId!, "BookingHeaderSimple", []).then(
                                        (e: any) => {
                                            this.props.history.push("/voucher-confirmed?id=" + e.localReffNo!);
                                        }
                                    ).catch(
                                        exc => {
                                            console.log(exc);
                                        }
                                    );
                                }
                            }
                        );

                    },
                    onListenToFirebaseError);
            }
        ).catch(
            exc => {
                console.log(exc);
            }
        );
    }

    render() {
        let txt = "Requesting Booking";

        if (this.state.fbRespons.statusCode === 'REQUESTING') {
            //  txt = "Charge Payment from stripe";
            return this.renderLoadingPanel(txt);
        } else if (this.state.fbRespons.statusCode === 'STRIPECHARD') {
            txt = "Charge Payment from stripe";
            return this.renderLoadingPanel(txt);
        } else if (this.state.fbRespons.statusCode === 'BOOKINGHOTELBED') {
            txt = "Request Booking Hotel";
            return this.renderLoadingPanel(txt);
        } else if (this.state.fbRespons.statusCode === 'ERROR') {
            return (
                <div style={{ paddingTop: 150 }}>
                    <div className="alert alert-block alert-danger fade in">
                        <h4 className="alert-heading margin-bottom-10"><i className="ti-close" />Your Booking Is Almost Complete. We Will Contact You Soon To Confirm</h4>
                        <p className="margin-bottom-10">
                            Please contact our sales team to complete your booking direct.
                        </p>
                        <p>
                            Email – <a href="mailto: info@balihotelsandmore.com?subject=Booking Error">info@balihotelsandmore.com</a> <br />
                            WhatsApp International Free Call : <a href="https://api.whatsapp.com/send?phone=6287860006919&text=Booking Error! Please Help" target="_blank">0878 6000 6919</a> <br />
                            Australia – <a href="cal:1300 582 556">1300 582 556</a><br />
                        </p>
                        <p>We cant wait to see you in Bali!</p>
                        <p>Don’t forget with every hotel booking you get more with Bali Hotels And More.</p>

                        <p>Book your room for just $1 and pay before you arrive. Bali Hotels And More offer the best luxury hotels at fantastic rates. All include</p>
                        <ul>
                            <li>FREE airport transfers with bookings over 5 days</li>
                            <li>FREE tours for kids valued at $450!  - <a href="https://www.balihotelsandmore.com/bali-tours">https://www.balihotelsandmore.com/bali-tours</a></li>
                            <li>Get 10% off travel insurance!</li>
                            <li>Save hundreds on Bali restaurants, beach clubs and spas. You’re now a VIP - <a href="http://www.baliholidaysandmorevip.com" target="_blank">http://www.baliholidaysandmorevip.com</a></li>
                            <li>We live here so we know what will make the most amazing Bali holiday memories!</li>
                        </ul>
                        <p>https://www.balihotelsandmore.com</p>
                    </div>
                    <div className="alert alert-danger">
                        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                        <strong>Original Error Message </strong>
                        {this.state.fbRespons.errorMessage ? this.state.fbRespons.errorMessage : "Unknown ERROR Message"}
                    </div>
                </div>
            );
        } else {
            return (
                <span >COMPLATE</span>
            );
        }

    }

    private renderLoadingPanel(txt: string): JSX.Element {

        return (

            <div className="col-md-12 bg-white" style={{ minHeight: 500, textAlign: "center", paddingTop: '150px' }}>
                <h4>Please Wait</h4>
                <h5>{txt}</h5>
                <div className='loader' />
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/new-booking/BookingChecoutProgressPanel.tsx